/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {placeRecurringOrder} from '../api'

export const useMutationPlaceRecurringOrder = createReactQueryMutationHook('placeRecurringOrder', placeRecurringOrder)
